// import Loader from 'common/components/Loader/Loader';
import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UserType as UserTypeType } from "types/UserType";
import UserTypeForm from "./UserTypeForm";

function UserType() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any =
    useItem<UserTypeType>("user-types", id);

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/usertypes");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataUserType: any) => {
      const newUserType = { ...dataUserType };

      try {
        if (newUserType.id) {
          await updateItem(newUserType.id, newUserType);
        } else {
          await saveItem(newUserType);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <UserTypeForm onSubmit={onSubmit} userType={item} />
  );
}

export default UserType;
